export enum ShipmentAction {
  Create = 'SHIPMENT_CREATED',
  AssignFleet = 'FLEET_ASSIGNED',
  AcceptFleet = 'FLEET_ACCEPTED',
  ReassignFleet = 'FLEET_REASSIGNED',
  AssignDriver = 'DRIVER_ASSIGNED',
  AcceptDriver = 'DRIVER_ACCEPTED',
  Start = 'TRIP_STARTED',
  ArrivePickupLocation = 'ARRIVED_AT_PICKUP_LOCATION',
  GoodsLoaded = 'GOODS_LOADED',
  ArriveDropOffLocation = 'ARRIVED_AT_DROP_OFF_LOCATION',
  GoodsDelivered = 'GOODS_DELIVERED',
  Cancel = 'CANCELED',
  NotFulfilled = 'NOT_FULFILLED',
  Reject = 'REJECTED',
  Decline = 'DECLINED',
  Close = 'CLOSED'
}
